var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-full justify-center items-center z-10",class:[_vm.stickToTop ? 'sticky top-0' : 'relative'],style:(`background-color: ${_vm.finalBgColor}`)},[_c('div',{staticClass:"w-11/12 lg:w-9/12"},[_c('div',{staticClass:"flex justify-between items-center pt-5 pb-3"},[_vm._t("logo"),_vm._t("profile"),_vm._t("button")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }